<template>
  <span v-if="errorCode" class="error-message">
    <v-icon>mdi-alert-circle-outline</v-icon> {{ errorMessage }}
    </span>
</template>

<script>

const ERROR_CODES = {
  212: 'No tienes permisos para acceder',
  401: 'Usuario o contraseña incorrectos',
  403: 'Usuario bloqueado',
};

const ERROR_CODE_GENERIC = 'Ha ocurrido un problema técnico.\nPor favor, inténtalo de nuevo más tarde.';

// const ERROR_CODES = {
//   0: 'No se pudo conectar con el servidor',
//   400: 'Solicitud incorrecta',
//   404: 'Recurso no encontrado',
//   405: 'Metodo no permitido',
//   408: 'Tiempo de espera agotado',
//   409: 'Conflicto con el estado actual del recurso',
//   410: 'Recurso no disponible',
//   412: 'No se cumple una condicion requerida',
//   413: 'La solicitud es demasiado grande',
//   415: 'Tipo de contenido no soportado',
//   422: 'No se pudo procesar la solicitud',
//   429: 'Demasiadas solicitudes, intenta de nuevo mas tarde',
//   212: 'No tienes permisos para acceder',
//   401: 'Usuario o contraseña incorrectos',
//   403: 'Acceso denegado',
//   500: 'Error del servidor',
//   501: 'Funcion no implementada en el servidor',
//   502: 'Respuesta invalida del servidor',
//   503: 'Servicio no disponible temporalmente',
//   504: 'El servidor tardo demasiado en responder',
// };

export default {
  props: {
    errorCode: {
      type: [String, Number],
      default: null,
    },
    errorLogin: {
      type: String,
      default: null,
    },
  },
  computed: {
    errorMessage() {
      console.log('Error code:', this.errorCode);
      /*
      TODO: El componente esta preparado para recibir tambien el texto de error
      Pero de momento solo usaremos el codigo de error
       */
      // if (this.errorLogin != null) {
      //   console.log('Error login:', this.errorLogin);
      //   return this.errorLogin;
      // }
      return ERROR_CODES[this.errorCode] || ERROR_CODE_GENERIC;
    },
  },
};
</script>

<style scoped>
.error-message {
  white-space: pre-line;
}
</style>
